import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
    root: {},
    marginBottom: {
        marginBottom: 20
    },
    divider: {
        marginBottom: 20,
        marginTop: 20
    },
    gridOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        padding: '6px !important'
    }
}));

const OrderSummary = ({ orderInfo = {
    trackingNumber: 'N/A',
    purchaseOrder: 'N/A',
    orderMasterControlNumber: 'N/A'
} }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Grid container>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary">
                    {orderInfo.trackingNumber}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {t('glassClaim.order.shipperNumber')}
                </Typography>
            </Grid>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary">
                    {orderInfo.vendorPurchaseOrder}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                    {t('glassClaim.order.orderNumber')}
                </Typography>
            </Grid>
            <Grid item xs={4} className={classes.gridOverflow}>
                <Typography noWrap variant="h5" color="textPrimary" align="right">
                    {orderInfo.orderMasterControlNumber}
                </Typography>
                <Typography variant="body2" color="textSecondary" align="right">
                    {t('glassClaim.order.omcNumber')}
                </Typography>
            </Grid>
        </Grid>
    );
};

OrderSummary.propTypes = {
    orderInfo: PropTypes.shape({
        trackingNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        vendorPurchaseOrder: PropTypes.string,
        orderMasterControlNumber: PropTypes.string
    })
};

export default OrderSummary;
